import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AnimationOption } from 'library-explorer';
import { SlideDTO } from '@app/model/slideDTO.model';

@Component({
    selector: 'app-question-scale',
    templateUrl: './question-scale.component.html',
    styleUrls: ['./question-scale.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => QuestionScaleComponent),
            multi: true
        }
    ],
    standalone: false
})
export class QuestionScaleComponent implements ControlValueAccessor {
  @Input() public data: SlideDTO;
  @Input() questionHash: string;
  @Input() animation: AnimationOption = AnimationOption.NONE;
  @Input() animationDelay = 0;
  
  onChange = (data: any) => {};
  onTouched = () => {};

  public answer = null;

  constructor() { }

  public writeValue(obj: any): void {
    this.answer = obj;
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
